import * as React from "react";

const SvgUnsnap = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <mask
      id="unsnap_svg__a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="currentColor" fillOpacity={0.92} d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#unsnap_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M22.36 22.057 1.883 1.659.472 3.076l3.392 3.379Q2 8.82 2 11.975q0 3.726 2.599 6.35 2.599 2.626 6.286 2.626L18 21v-.464l2.949 2.938zm-7.517-4.665L6.42 9.002q-.866 1.299-.866 2.973 0 2.244 1.555 3.815t3.776 1.57zm5.692.024L22 18.875v-1.459zM6.958 3.891l2.816 2.805q.533-.106 1.111-.106h7.108V3h-7.108q-2.148 0-3.927.891M20 3h2v3.59h-2z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default SvgUnsnap;
